import React from "react";
import { useState } from "react";
import {
  RESIGN_NAUTICAL,
  ISSUE_COPY_NAUTICAL,
  NEW_NAUTICAL_APPLICATION_CHART,
} from "../../../../constants";
import IssueCopyNauticalCheckboxes from "./IssueCopyNauticalCheckboxes";
import NewNauticalCheckboxes from "./NewNauticalCheckBoxes";
import ResignNauticalCheckboxes from "./ResignNauticalCheckboxes";
import ls from "local-storage";

const CheckBoxesForCustomText = ({ applicationId, disableAll }) => {
  const [nauticalPdColor] = useState(() => ls.get("nauticalPdColor"));

  const getCustomTextWithId = (applicationID) => {
    const parsedApplicationID = parseInt(applicationID);
    switch (parsedApplicationID) {
      case NEW_NAUTICAL_APPLICATION_CHART:
        return (
          <NewNauticalCheckboxes
            nauticalPdColor={nauticalPdColor}
            disableAll={disableAll}
          />
        );
      case RESIGN_NAUTICAL:
        return (
          <ResignNauticalCheckboxes
            nauticalPdColor={nauticalPdColor}
            disableAll={disableAll}
          />
        );
      case ISSUE_COPY_NAUTICAL:
        return <IssueCopyNauticalCheckboxes disableAll={disableAll} />;
      default:
        break;
    }
  };
  return <>{getCustomTextWithId(applicationId)}</>;
};

export default CheckBoxesForCustomText;
